import React, {useState} from 'react';
import {formatNumber} from '../../../assets/utils/utils';
import {useTranslation} from 'react-i18next';
import {monthNow} from '../../../assets/utils/dateUtils';
import {useGetStatLidersQuery} from '../../../redux/myDynamicApi';
import LightGreenButton from '../../../Components/Buttons/LightGreenButton';

const LidersStat: React.FC = () => {
	const {t} = useTranslation();
	const {data, isFetching} = useGetStatLidersQuery({
		month: monthNow(),
		type_sort: '',
	});
	const [showAll, setShowAll] = useState(false);
	return (
		<div className="page__teamleaders teamleaders">
			<div className="teamleaders__title name">{t('Лідери команди')}</div>
			{/*<div className="teamleaders__filter filter">
				<button className="filter__btn btn-main btn-main-plus">
					<span> </span> добавить фильтр
				</button>
				<div className="filter__form form-filter">
					<form action="#" className="form-filter">
						<select
							name="volume"
							className="form-filter__select"
							defaultValue={'ЛИЧНОГО ОБЬЕМА'}
						>
							<option value="ЛИЧНОГО ОБЬЕМА">ЛИЧНОГО ОБЬЕМА</option>
							<option value="ЛИЧНОГО ОБЬЕМА">ЛИЧНОГО ОБЬЕМА</option>
							<option value="ЛИЧНОГО ОБЬЕМА">ЛИЧНОГО ОБЬЕМА</option>
						</select>
					</form>
				</div>
			</div>*/}
			<div className="teamleaders__row">
				{data?.stats?.map((p: any, index: number) => {
					if (index <= 9) {
						return (
							<div
								className="teamleaders__column"
								key={`teamleaders__row + ${index}`}
							>
								<span>{index + 1}</span>
								<div className="teamleaders__item item-team">
									<div className="item-team__column">
										<div className="item-team__name">
											{p.name}
											<span>{p.qlfc}</span>
											<span>
												{p.level} {t('лiнiя')}
											</span>
										</div>
									</div>
									<div className="item-team__column">
										<div className="item-team__point">
											{formatNumber(p.tree_points)} {t('Бали')}
										</div>
									</div>
								</div>
							</div>
						);
					} else return null;
				})}
				<div
					className="teamleader-hidden-columns"
					style={{display: showAll ? 'block' : ''}}
				>
					{data?.stats?.map((p: any, index: number) => {
						if (index > 9) {
							return (
								<div
									className="teamleaders__column"
									key={`teamleaders__column + ${index}`}
								>
									<span>{index + 1}</span>
									<div className="teamleaders__item item-team">
										<div className="item-team__column">
											<div className="item-team__name">
												{p.name}
												<span>
													{p.level} {t('лiнiя')}
												</span>
											</div>
										</div>
										<div className="item-team__column">
											<div className="item-team__point">
												{p.tree_points} {t('Бали')}
											</div>
										</div>
									</div>
								</div>
							);
						} else return null;
					})}
				</div>
			</div>
			{!showAll && data && data?.stats?.length > 9 && (
				<div className="teamleaders__btn">
					<LightGreenButton
						type={'button'}
						loading={isFetching}
						text={'Дивитися більше'}
						onClick={() => setShowAll(true)}
					/>
				</div>
			)}
		</div>
	);
};

export default LidersStat;
